import { render, staticRenderFns } from "./LomBankDetailsEdit.vue?vue&type=template&id=4c47ea74"
import script from "./LomBankDetailsEdit.vue?vue&type=script&lang=js"
export * from "./LomBankDetailsEdit.vue?vue&type=script&lang=js"
import style0 from "./LomBankDetailsEdit.vue?vue&type=style&index=0&id=4c47ea74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports